module.exports = __webpack_public_path__ + "img/index28.2c8be789.png";